import { setLoading, setGlobalMessage } from '../../../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, GLOBAL_VALUES } from 'eebac/constants';
import { Catch } from '../../../api_exception';

const BASE_PATH = "COMPANY_WORK_SCHEDULES";

export const loadSchedules = (rowsPerPage = null, page = null, clearExisting = true, resetFilters = false) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        dispatch(isLoadingRecords(true));

        let state = getState().COMPANY_WORK_SCHEDULES;

        let filters = [];

        if (!resetFilters) {
            if (state.vendor) {
                filters.push({ name: "vendor", values: [state.vendor] });
            }

            if (state.state) {
                filters.push({ name: "state", values: [state.state] });
            }

            if (state.city && Array.isArray(state.city) && state.city.length > 0) {
                filters.push({ name: "city", values: state.city });
            }

            if (state.workType && Array.isArray(state.workType) && state.workType.length > 0) {
                filters.push({ name: "workType", values: state.workType });
            }
        }

        let apiData = {
            itemsCount: state.rowsPerPage,
            currentPage: state.page + 1,
        }

        if (filters.length > 0) {
            apiData.filters = filters;
        }

        if (rowsPerPage) {
            apiData.itemsCount = rowsPerPage;
        }

        if (page !== null) {
            apiData.currentPage = page + 1;
        }

        if (clearExisting) {
            dispatch(setSchedulesData([], 0, apiData.itemsCount, 0));
        }

        client.post('/company/meeting_schedules', apiData).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.schedules) {
                    dispatch(setSchedulesData(result.data.schedules,
                        (result.currentPage - 1), result.itemsCount, result.totalCount));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
                dispatch(isLoadingRecords(false));
            }).catch(error => {
                dispatch(isLoadingRecords(false));
                Catch(error, dispatch);
            });
    }

export const loadSchedule = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.get(`/company/meeting_schedule/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.schedule) {
                    dispatch(setScheduleData(result.data.schedule));
                    dispatch(viewSchedule(true));
                } else {
                    dispatch(setScheduleData(null));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                    dispatch(viewSchedule(false));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setScheduleData(null));
            });
    }

export const deleteSchedule = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.delete(`/company/meeting_schedule/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    dispatch(loadSchedules());
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
            });
    }


export const SET_SCHEDULES_DATA = `${BASE_PATH}/SET_SCHEDULES_DATA`;
export const SET_FILTERS_DATA = `${BASE_PATH}/SET_FILTERS_DATA`;
export const SET_SCHEDULE = `${BASE_PATH}/SET_SCHEDULE`;
export const VIEW_SCHEDULE = `${BASE_PATH}/VIEW_SCHEDULE`;
export const OPEN_CONFIRM_DIALOG = `${BASE_PATH}/OPEN_CONFIRM_DIALOG`;
export const SET_LOADING_RECORDS = `${BASE_PATH}/SET_LOADING_RECORDS`;

export const setSchedulesData = (schedules, page, rowsPerPage, totalRows) => ({
    type: SET_SCHEDULES_DATA,
    schedules,
    page,
    rowsPerPage,
    totalRows
});

export const viewSchedule = (open) => ({
    type: VIEW_SCHEDULE,
    open
});

export const setFiltersData = (data) => ({
    type: SET_FILTERS_DATA,
    data
});

export const setScheduleData = (data) => ({
    type: SET_SCHEDULE,
    data
});

export const openConfirmDialog = (open, selectedId) => ({
    type: OPEN_CONFIRM_DIALOG,
    open,
    selectedId
});

export const isLoadingRecords = (isLoadingRecords) => ({
    type: SET_LOADING_RECORDS,
    isLoadingRecords
});

const initialState = {
    schedules: [],
    page: 0,
    rowsPerPage: GLOBAL_VALUES.DEFAULT_ROWS_PER_PAGE,
    totalRows: 0,

    state: '',
    city: [],
    firmType: [],
    workType: [],

    stateError: '',
    cityError: '',
    firmTypeError: '',
    workTypeError: '',

    viewSchedule: false,
    scheduleData: null,

    selectedId: null,
    openConfirmDialog: false,
    isLoadingRecords: false
}

export default function reducer(state = { ...initialState }, action) {
    let newState = null;
    switch (action.type) {
        case SET_SCHEDULES_DATA:
            newState = {
                ...state,
                schedules: [...action.schedules],
                page: action.page,
                rowsPerPage: action.rowsPerPage,
                totalRows: action.totalRows
            };
            return newState;
        case SET_FILTERS_DATA:
            newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case VIEW_SCHEDULE:
            return { ...state, viewSchedule: action.open };
        case SET_SCHEDULE:
            return {
                ...state,
                scheduleData: action.data
            }
        case OPEN_CONFIRM_DIALOG:
            return {
                ...state,
                openConfirmDialog: action.open,
                selectedId: action.selectedId
            }
        case SET_LOADING_RECORDS:
            return {
                ...state,
                isLoadingRecords: action.isLoadingRecords
            }
    }

    return state;
}